export default __webpack_public_path__ + "static/media/clapping.49dd064a.wav";